import { Formatters, Messages } from '../../codegen/Localize';
import { ActionHelpers, standardActionErrorMsg, standardActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { SchedulingErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { FlowContentType } from '../../ts/models/ContentTypes';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { Set } from '../../ts/models/Set';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { RunFlowTasks } from '../resources/RunFlowTasks';

export function showResumeRunFlowTasksActionDialog(runFlowTaskInfos: Set<RunFlowTaskInfo>): Promise<any> {
  const message: string = Messages.runFlowTasksConfirmResume({
    TASK_COUNT: runFlowTaskInfos.size(),
    TASK_COUNT_LOC: Formatters.formatCount(runFlowTaskInfos.size()),
  });

  const dialogInstance = openReactConfirmationDialog<void, IResult>({
    title: Messages.runFlowTasksResume(),
    message: message,
    paramsForAction: undefined,
    actionName: Messages.runFlowTasksResume(),
    action: () => RunFlowTasks.resume(runFlowTaskInfos.keys()),
    dialogWidth: TabDialogWidth.width375px,
  });

  dialogInstance.result.then(result => ActionHelpers.displayStandardToastsForResult(
    runFlowTaskInfos,
    result,
    {
      success: standardActionSuccessMsg(Messages.runFlowTasksResumeSuccess),
      error: standardActionErrorMsg(Messages.runFlowTasksResumeError),
    },
    (errorItem: IErrorItem<RunFlowTaskInfo>) => {
      const namedItem: INamedItemInfo = errorItem.item.flow;
      return {
        itemName: namedItem.name,
        itemUrl: ContentUrlForItem(errorItem.item.flow, FlowContentType),
        errorMessage: errorMessageFor(errorItem)
      };
    }
  ));

  return Promise.resolve(dialogInstance.result);
}

function errorMessageFor(errorItem: IErrorItem<RunFlowTaskInfo>) {
  switch (errorItem.error.code) {
    case SchedulingErrorCode.SchedulingTaskNotFound:
      return Messages.errorRunFlowTaskNotFound({
        FLOW_NAME: L10n.elideIfLong(errorItem.item.flow.name),
        SCHEDULE_NAME: L10n.elideIfLong(errorItem.item.schedule.name)
      });
    default:
      return Messages.errorUnknown();
  }
}
